import Script from 'next/script'
import { memo } from 'react'

interface IPropTypes {
  appId: string
}
function TrengoChat({ appId = '' }: IPropTypes) {
  if (!appId) return <></>
  return (
    <Script
      id='trengo-init'
      strategy='afterInteractive'
      type='text/javascript'
      dangerouslySetInnerHTML={{
        __html: `
        window.Trengo = window.Trengo || {};
        window.Trengo.key = '${appId}';
        (function(d, script, t) {
            script = d.createElement('script');
            script.type = 'text/javascript';
            script.async = true;
            script.src = 'https://static.widget.trengo.eu/embed.js';
            d.getElementsByTagName('head')[0].appendChild(script);
        }(document));
        `,
      }}
    />
  )
}

export default memo(TrengoChat)
